module.exports = __webpack_public_path__ + "img/DangerousGoods.66843e72.svg";